import { useMutation } from '@tanstack/react-query';
import { apiClient } from '../apiClient';
import { getQueryKeyBase, MUTATION_KEYS } from '../queryClient';
import { updateCacheArray, CACHE_ACTIONS } from '../cacheClient';
import { getQueryKey } from './useCriteriaResources';

// Config
import { uiConfig } from '../../../conf/criteriaResources';

export const getMutationKey = getQueryKeyBase.bind(null, MUTATION_KEYS.CRITERIA_RESOURCES);

export const useDeleteResource = ({ crudConfig, sessionToken, onSuccessCb, onErrorCb }) => {
    const Client = apiClient(crudConfig);

    return useMutation({
        mutationKey: getMutationKey(),
        mutationFn: (resourceId) => Client.delete(sessionToken, resourceId),
        onSuccess: (data) => {
            updateCacheArray({
                queryKey: getQueryKey(),
                action: CACHE_ACTIONS.REMOVE,
                primaryKey: uiConfig.primaryKey,
                data
            });
            onSuccessCb?.();
        },
        onError: (error) => {
            console.log('Error', error);
            onErrorCb?.(error);
        },
        refetchOnWindowFocus: false
    });
};
